<template>
  <Component
    :is="tag"
    :class="innerClass"
    class="base-layout-spread"
  >
    <slot />
  </Component>
</template>

<script lang="ts" setup>
interface Props {
  tag?: string
  innerClass?: string
}
withDefaults(defineProps<Props>(), {
  tag: 'div',
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.base-layout-spread {
  padding-left: 1rem;
  padding-right: 1rem;
  @include is-tablet {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}
</style>
